import I18n from '../utilities/translations.js.erb'
import $ from 'jquery';
import jQuery from 'jquery';
import 'jquery-ui';
const $t = key => I18n.t(`javascript.packs.payments${key}`)

async function initPayments(publicKey, locale='en') {
  I18n.locale = locale
  const feeData = document.getElementById('fee-data')
  const connected_account = feeData.dataset.account

  const stripe = (connected_account != '') ? Stripe(publicKey, {locale: locale, stripeAccount: connected_account}) : Stripe(publicKey, {locale: locale})

  const style = { base: { fontSize: '16px', '::placeholder': { color: '#b2c6cd' }}}

  const cardholderName = document.getElementById('cardholder-name')
  const cardButton = document.getElementById('card-button')
  const troktCheck = document.getElementById('service_fee_trokt_enabled')
  const setupClientSecret = cardButton?.dataset?.secret
  const paymentClientSecret = feeData.dataset.piSecret
  const troktHandling = feeData.dataset.troktHandling
  const payment_method = feeData.dataset.paymentMethod
  const status = feeData.dataset.feeStatus
  const lastError = feeData.dataset.lastErrorMsg
  const nextStep = feeData.dataset.nextStep
  const negotiation_id = feeData.dataset.negotiationId
  const normalFlow = true //status !== 'failed'
  if (status === 'pending') {
    await reAuthentication()
    return
  }
  else if (status !== 'created' && status !== 'failed') {
    if (status === 'success')
      showFlash($t('.charged_successfully'), false)
    return
  }

  const elements = stripe.elements()
  const cardElement = elements.create('card', {style})
  if (cardButton){
    cardElement.mount('#card-element')
  }
  function showFlash(message, error=true) {
    let flashEl = jQuery('#payment-error-flash')
    if (error) {
      flashEl.removeClass('d-none')
      flashEl.removeClass('alert-success')
      flashEl.addClass('alert-danger')
    } else {
      flashEl.addClass('d-none')
      flashEl.removeClass('alert-danger')
      flashEl.addClass('alert-success')
    }
    flashEl.find('.message').text(message)
    flashEl.show()
    flashEl.find('.close').click(_ => flashEl.hide())
  }
  function showLoading() { jQuery(cardButton).button(); }
  function hideLoading() { jQuery(cardButton).button() }
  function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)) }

  async function reAuthentication() {
    const {paymentIntent, error} = await stripe.confirmCardPayment(paymentClientSecret, {payment_method})
    if (error)
      showFlash(error.message)
      // If it fails at this point, we should probably set the ServiceFee status to failed
      // and ask for another Credit Card (or Debit Card)
      // Open Payments Flowchart in http://draw.io for info about the different states a fee can be in.
      // You can find the Flowchart here: app/cases/payments/payment_flow.drawio
    else if (paymentIntent.status === 'succeeded') {
      showFlash($t('.payment_successful'), false)
    }
  }

  async function saveCard(ev) {
    ev.preventDefault()

    const acceptCheck = document.getElementById('accept')
    if ( !cardholderName.value ) {
      showFlash($t('.provide_cardholder_name'))
      return
    }
    if (acceptCheck){
      if (acceptCheck.checked == false){
        showFlash($t('.must_accept'), true)
        return
      }
    }

    showLoading()

    const confirmData = {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: cardholderName.value,
        },
      },
    }

    let result
    if (normalFlow)
      result = await stripe.confirmCardSetup(setupClientSecret, confirmData)
    else {
      confirmData.setup_future_usage = 'off_session'
      result = await stripe.confirmCardPayment(paymentClientSecret, confirmData)
    }

    if (result.error) {
      showFlash(result.error.message)
    } else if (result.setupIntent?.status === 'succeeded' || result.paymentIntent?.status === 'succeeded') {
      if (normalFlow) {
        showFlash($t('.card_is_being_processed'), false)
        //await sleep(3000)
        // pop in the opt-in checkbox here and then post to wherever we want to

        $.ajaxSetup({
           headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
        });
        let use_trokt = false;
        if (troktHandling == "always"){
          use_trokt = true;
        } else if (troktHandling == "never"){
          use_trokt = false;
        } else {
          use_trokt = troktCheck.checked;
        }

        $.ajax({
          type: "POST",
          url: nextStep + "_trokt",
          data: { trokt_enabled: use_trokt, case_id: negotiation_id },
          success: function(result){
               //submit stripe form only if the survey data saved
               if (result['success'] == "true"){
                window.location = result['html'];
               } else {
                $('#payment_intake').html(result['html']);
               }
          },
          error: function(){
               //handle error situation if post request failed
          }
        });
      }
      else {
        showFlash($t('.payment_successful'), false)
      }
    }
    hideLoading()
  }
  async function skipCard(ev) {
    ev.preventDefault()
    let acceptCheck = document.getElementById('accept');

    if (acceptCheck){
      if (acceptCheck.checked == false){
        showFlash($t('.must_accept'), true);
        return
      }
    }
   
    window.location = ev.target.href;
  }
  let nextButton = document.getElementById('skip-next');
  if (nextButton){
    nextButton.addEventListener('click', skipCard);
  }

  if (cardButton){
    cardButton.addEventListener('click', saveCard)
  }
  if (lastError)
    showFlash(lastError)
}

window.initPayments = initPayments
